import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import { Route16 } from '@cian/ui-kit/icons';

import * as styles from './MapRouteButton.css';

interface IMapRouteButtonProps {
  onClick?(): void;
}

export const MapRouteButton = React.forwardRef<HTMLButtonElement, IMapRouteButtonProps>(({ onClick }, ref) => {
  return (
    <button ref={ref} className={styles['button']} onClick={onClick} type="button">
      <Route16 color="primary_100" />
      <UIText2 color="primary_100" fontWeight="bold">
        Построить маршрут
      </UIText2>
    </button>
  );
});

MapRouteButton.displayName = 'MapRouteButton';
